/**
 * /en/admin/structure/paragraphs_type/form_element_label/fields
 */

import { ATTRIBUTES, HTML_ELEMENTS } from "../constants/html-constants.es6.js"
import Element from "../core/element.es6.js"
import Paragraph from "../core/paragraph.es6.js";

export default class LabelFormElementParagraph extends Paragraph {
  get label() {
    return new Element({
      parentElement: this,
      selector: `> ${HTML_ELEMENTS.LABEL}:first-of-type`,
    });
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_label',
      parentElement,
    });
  }

  toggleRequirement(required) {
    const $label = this.$().find(HTML_ELEMENTS.LABEL);

    if (required) {
      $label.attr(ATTRIBUTES.CUSTOM_REQUIRED, true);
    } else {
      $label.removeAttr(ATTRIBUTES.CUSTOM_REQUIRED);
    }
  }
}
